
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import FiltersContainer from "@/components/filters/filters-container.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import CompaniesMultiselect from "@/components/autocompleteMultiselects/CompaniesMultiselect.vue";
  import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselectV2.vue";
  import DocumentsContractorProjectsFilters from "@/entities/filters/DocumentsContractorProjectsFilters";

  @Component({
    components: {
      ProjectsMultiselect,
      CompaniesMultiselect,
      FormGroup,
      FiltersContainer,
    },
  })
  export default class DocumentsContractorProjectFilters extends Vue {
    @Prop({ type: Object, required: true }) readonly filters!: DocumentsContractorProjectsFilters;

    fileName: string = "";
    selectedProjectsIds: string[] = [];
    selectedCompaniesIds: string[] = [];

    get filtersToWatch(): string {
      return JSON.stringify([
        this.fileName,
        this.selectedProjectsIds,
        this.selectedCompaniesIds,
      ]);
    }

    @Watch("filters", { immediate: true })
    updateFiltersValues(): void {
      this.fileName = this.filters.file_name;
      this.selectedProjectsIds = this.filters.projects;
      this.selectedCompaniesIds = this.filters.companies;
    }

    @Watch("filtersToWatch")
    handlePropToWatchChange(): void {
      const filters: DocumentsContractorProjectsFilters = {
        file_name: this.fileName,
        projects: this.selectedProjectsIds,
        companies: this.selectedCompaniesIds,
      };

      this.$emit("filtersChanged", filters);
    }

    handleReset(): void {
      this.$emit("resetFilters");
    }
  }
